import Card from 'components/Layout/Card';
import React, { useEffect, useState } from 'react';
import FullPaperAddPopup from './FullPaperAddPopup';
import { fetchAbstractFullPaper } from 'store/slices';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Loader from 'components/Layout/Loader';
import Button from 'components/form/Button';
import { eventAbstarctPath, icons } from 'utils/constants';
import moment from 'moment';
import { generatePreSignedUrl, handleFileDownload } from 'utils/helpers';
import usePermission from 'hooks/usePermission';

const FullPaper = () => {
  const dispatch = useDispatch();
  const { paperId } = useParams();
  const [fullPaperData, setFullPaperData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
    const { viewAccess, createAccess, updateAccess, deleteAccess } = usePermission('Event Management');


  const getAbstractFullPaper = async () => {
    setIsLoading(true);
    const response = await dispatch(fetchAbstractFullPaper(paperId));
    if (response?.status === 200 && Array.isArray(response?.data)) {
      setFullPaperData(response?.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getAbstractFullPaper();
  }, [paperId]);

  const handleViewPreview = async (previewFile, eventAbstarctPath) => {
    if (previewFile) {
      const res = await generatePreSignedUrl(previewFile, eventAbstarctPath);
      const fileEx = previewFile?.split('.')?.pop();

      if (fileEx !== 'pdf') {
        const googleDocsUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
          res
        )}&embedded=true`;
        window.open(googleDocsUrl, '_blank');
      } else {
        window.open(res, '_blank');
      }
    }
  };

  return (
    <Card className="cp-24">
      {isLoading ? (
        <Loader size="sm" />
      ) : fullPaperData?.length === 0 ? (
        <>
          <div className="text-16-500-20">
            Do you want to upload your full paper?
          </div>

          {createAccess === "1" &&
          <div className="d-flex cmt-16">
            <FullPaperAddPopup getAbstractFullPaper={getAbstractFullPaper} />
          </div>}
        </>
      ) : (
        <>
          <div className="text-16-500-20 cmb-16">Full Paper Submitted:</div>

          {fullPaperData?.map((item, index) => (
            <div key={item.id} className="mb-4">
              <div className="text-14-400-18">
                Full Paper Upload ({index + 1}):
              </div>

              <div className="cmt-16 text-14-300-18 color-black-olive">
                <img src={icons.calendarCheck} alt="" className="me-2" />
                {moment(item.created_at).format('DD-MMMM-YYYY')}
              </div>

              {item?.comment ? (
                <>
                  <div className="cmt-16 text-14-400-18 color-black-olive">
                    Comment
                  </div>

                  <div className="cmt-10 text-14-400-18 color-black-olive">
                    {item?.comment}
                  </div>
                </>
              ) : (
                <div className="cmt-16 text-14-300-24 color-black-olive">
                  You have successfully submitted your full paper!
                </div>
              )}

              <div className="d-flex gap-3 cmt-16">
                <Button
                  text="View Full Paper"
                  icon={
                    <span className="me-2">
                      <img src={icons.DarkBlueEye} alt="view" />
                    </span>
                  }
                  btnStyle="primary-outline1"
                  className="h-35 cps-15 cpe-15"
                  onClick={() =>
                    handleViewPreview(item?.full_paper, eventAbstarctPath)
                  }
                />
                <Button
                  text="Download Full Paper"
                  icon={
                    <span className="me-2">
                      <img src={icons.whiteExport} alt="download" />
                    </span>
                  }
                  btnStyle="primary-dark"
                  className="h-35 cps-15 cpe-15"
                  onClick={(e) =>
                    handleFileDownload(e, item?.full_paper, eventAbstarctPath)
                  }
                />
              </div>
            </div>
          ))}

          <FullPaperAddPopup
            type="ReUpload"
            getAbstractFullPaper={getAbstractFullPaper}
          />
        </>
      )}
    </Card>
  );
};

export default FullPaper;
